<template>
  <div @click="hideMe" class="menu-overlay has-background-primary is-vertical-center" v-show="visible">
    <div class="has-text-centered is-fullwidth is-size-3">
      <div class="g-menu-list">
        <span><router-link :to="{ name: 'Home'}" class="has-text-black">{{ 'Home' | translate }}</router-link></span>
        <span><router-link :to="{ name: 'Profile'}" class="has-text-black">{{ 'Profile' | translate }}</router-link></span>
      </div>
      <hr class="has-background-black"><br>
      <div class="g-menu-list">
        <span v-for="tag in tags" :key="tag.name">
          <router-link :to="{ name: 'TagPage', params: { name: tag.name }}" class="has-text-black">{{ $t(tag.name) }}</router-link>
        </span>
      </div>
    </div>
    <div class="close-icon">
      <img src="@/../static/gamega.me/close_black.svg" class="is-medium icon">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Menu',
  props: ['show'],
  data () {
    return {
      visible: this.show
    }
  },
  computed: {
    ...mapState({
      tags: state => state.games.tags
    })
  },
  methods: {
    showMe() {
      this.visible = true
    }, 
    hideMe() {
      this.visible = false
    }
  }
}
</script>

<style>
.menu-overlay {
  position:fixed;
  top:0;
  right:0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}
.close-icon {
  position:absolute;
  top:1rem;
  right:0.5rem;
}
.g-menu-list {
  display: grid;
  grid-template-columns: repeat(1,minmax(0,1fr))
}
@media (max-height: 600px) and (orientation: landscape) { 
  .g-menu-list {
    grid-template-columns: repeat(2,minmax(0,1fr))
  }
}
</style>


// WEBPACK FOOTER //
// src/components/LangGG/Menu.vue